import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEO />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: 'jm天堂 - 官方入口与完整使用指南',
          description:
            'jm天堂是深受用户喜爱的内容平台，本页为您提供jm天堂的官方入口、最新地址、使用教程及常见问题解答，帮助您快速访问jm天堂，畅享丰富内容资源。',
        }}
      />
      <HeroSection />
      <CategoryCards />
      <LatestArticles />
      <FAQSection />
      <CTASection />
    </>
  );
}